import React, {useState, useEffect} from 'react'
import {InputNumber, Modal, Button, Spin, List, message, Carousel } from 'antd'
import styles from '../layout.module.less'
import{addVisitLog, history} from 'libs';
import NumberInput from "../../../components/NumberInput";
import hotImg from '../list/hot.png'

import {observer} from 'mobx-react';
import store from '../store'
// import http from "../../../libs/http";
// import lodash from "lodash"

// the hook
import { useTranslation } from 'react-i18next';

import ImageMagnifier from 'components/ImageMagnifier'
import cartStore from "../../cart/store";
import noImg from './noImg.png'
import detailBg from './detail_bg.png'
import defaultGoodsPicture from '../list/default-picture.png'
import prevArrow from './custom_left.png'
import nextArrow from './custom_right.png'

export default observer(function (props) {
  const { t, i18n } = useTranslation();

  const [picLength, setPicLength] = useState(4)
  const [visible, setVisible] = useState(false)
  const [isBuy, setIsBuy] = useState(false)
  const [picIndex, setPicIndex] = useState(0)
  const [translateX, setTranslateX] = useState(5/192)
  const [num, setNum] = useState(1)
  const [loadingMap, setLoadingMap] = useState({}) // 存储按钮加载状态
  const step = 119
  const carouselRef = React.createRef();
  const data = Object.assign({}, store.record)
  const query = props.location.search // '?s=1&f=7'
  const arr = query.split('=') // ['?s=', 'f=7']
  let id = arr[1]

  useEffect(() => {
    if (store.recordId === id) return

    store.record = {}
    let key = 'goodsDetail'
    message.loading({content: 'Loading...', key})
    store.recordId = id
    store.fetchRecord(i18n.language).then(() => {
      setPicLength(store.record['mainImageList'] ? store.record['mainImageList']?.length : 0)
    }).finally(() => message.destroy(key))
    store.hotRecords.length === 0 && store.fetchHotRecords();
  }, [id,i18n.language])

  // useEffect(() => {
  //   store.fetchRecord(i18n.language);
  // }, [i18n.language])


  // 生成图片列表
  const picListItems = () => {
    let imgList = []
    if (store.record['mainImageList']?.length) {
      store.record['mainImageList'].map((pic, index) =>
      imgList.push((
        <div
          key={index}
          onMouseEnter={() => setPicIndex(index)}
          className={[styles.pic, picIndex === index ? styles.cur : ""].join(" ")}
          style={{backgroundImage: 'url(' + pic + ')'}}
        />
      ))
    )
    }
    return imgList
  }

  // // 控制图片移动
  // const handleMove = (moveRight = true) => {
  //   let newVal = translateX + (moveRight ? step : -step)
  //   newVal <= 5 && newVal >= -(picLength - 4) * step && setTranslateX(newVal/192)
  // }

  //加入购物车 - 添加防重复点击
  const handleBuy = async (isBuy = true) => {
    const key = `buy-${isBuy}`;
    if (loadingMap[key]) return; // 正在加载中，阻止重复点击

    let eventCode = 'ProductDetailRent';
    let eventName = '产品详情租';
    if (isBuy) {
      eventCode = 'ProductDetailSale';
      eventName = '产品详情买';
    }

    addVisitLog({
      pageName: eventName,
      fromPageUrl: window.referrerUrl,
      pageUrl: `${window.location.origin}${history.location.pathname}`,
      eventCode: eventCode,
      eventName: eventName,
    });

    // 设置加载状态
    setLoadingMap(prev => ({ ...prev, [key]: true }));

    try {
      await cartStore.addRecord(store.recordId, isBuy ? 'Sale' : 'Rent', num);
      setVisible(true);
      setIsBuy(isBuy);
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      // 清除加载状态
      setLoadingMap(prev => ({ ...prev, [key]: false }));
    }
  }
  //切换图片
  const changeCarousel = (status)=>{
    const { currentSlide,slideCount } = carouselRef.current.innerSlider.state
    if(status === 'prev' && currentSlide > 0){
      carouselRef.current.prev()
    }
    if(status === 'next' && currentSlide+1 < slideCount){
      carouselRef.current.next()
    }
  }
  const showHtml = (htmlString) => {
    let html = {__html: htmlString};
    return <div dangerouslySetInnerHTML={html}/>;
  }


  return (
    <React.Fragment>

      {!store.record['name'] ? (
        <div style={{textAlign: 'center', margin: '50px auto'}}><Spin tip="Loading..."/></div>) : (

        <div className={styles.detailContent}>

          <div className={styles.goodsInfo}>
            {/* <div className={styles.picShow}>
              <div className={styles.curPic}>
                <ImageMagnifier className={styles.pic} minImg={data['mainImageList']&&data['mainImageList'][picIndex]}
                                maxImg={data['mainImageList']&&data['mainImageList'][picIndex]}/>
              </div>
              <div className={styles.picBox}>
                <div onClick={handleMove.bind(this, true)} className={styles.leftBtn}>
                  <i className='icon icon-xiala'/>
                </div>
                <div className={styles.picInnerBox}>
                  <div className={styles.picList} style={{
                    transform: 'translateX(' + translateX + 'rem)',
                    width: picLength * step
                  }}>
                    {picListItems()}
                  </div>
                </div>
                <div onClick={handleMove.bind(this, false)} className={styles.rightBtn}>
                  <i className='icon icon-xiala'/>
                </div>
              </div>
            </div> */}
            <div className={styles.picList}>
              <div className={styles.brand_info}>
                <div>{data.brand}</div>
                <div className={styles.spline}></div>
                <div>{data['factoryCode']}</div>
                <img className={styles.brand_info_bg} src={detailBg}/>
              </div>
              {
                store.record['mainImageList']?.length ? 
                <Carousel ref={carouselRef}>
                  {
                    store.record['mainImageList'].map((pic,index)=>{
                      return <img src={pic}/>
                    })
                  }
                </Carousel> :
                <div className={styles.defaultPicture}>
                  <img src={defaultGoodsPicture}/>
                </div>
              }
              {
              store.record['mainImageList']?.length > 1 ? (
                <div className={styles.custom_arrow}>
                  <div className={styles.common_arrow} onClick={()=>changeCarousel('prev')}>
                    <img src={prevArrow} alt=''/>
                  </div>
                  <div className={styles.common_arrow} onClick={()=>changeCarousel('next')}>
                    <img src={nextArrow} alt=''/>
                  </div>
                </div>
                ) : null
              }
            </div>
            <div className={styles.info}>
              <div className={styles.name}>{data['name']}{data.isHot?<img className={styles.hotImg} src={hotImg} alt="" />:''}</div>
              <div className={styles.brand}>{data.brand}</div>
              {/* <div className={styles.price} hidden={true}>
                <p>泉心价：<span className={styles.val}><span className={styles.lg}>¥ 879.90</span> / 个</span></p>
                <p>市场价：<span className={styles.val}>¥ 979.00 / 个</span></p>
              </div> */}
              <div className={styles.other}>
                <p>{t('型 号')}：<span className={styles.val}>{data['factoryCode']}</span></p>
                <p>{t('规 格')}：<span className={styles.val}>{data['formats']}</span></p>
              </div>
              <div className={styles.store}>
                <NumberInput 
                    className="goods_inputNum goods_detail_inputNum"
                    min={1}
                    max={data['stock']}
                    value={num}
                    onChange={(num) => setNum(num)}/>
                    <span className={styles.unit}>{t('台')}</span>
              </div>
              <div className={styles.btnGroup}>
                {!data['leaseAble'] ? null : (
                  <div
                    onClick={() => handleBuy(false)}
                    className={styles.btn1}
                  >
                    {loadingMap['buy-false'] ? t('处理中...') : t('我要租')}
                  </div>
                )}
                {!data['saleAble'] ? null : (
                  <div
                    onClick={() => handleBuy(true)}
                    className={styles.btn2}
                  >
                    {loadingMap['buy-true'] ? t('处理中...') : t('我要买')}
                  </div>
                )}
              </div>
            </div>

          </div>

          <div className={styles.moreInfo}>
           

            <div className={styles.richText}>
              <div className={styles.title}>{t('产品详情')}</div>
              <div className={styles.pre}>
                {showHtml(data.details)}
              </div>
            </div>
{/* 
            <div className={styles.related}>
              <div className={styles.title}>{t('设备推荐')}</div>
              <div className={styles.list}>
                {
                  store.hotRecords.map((item,index)=>{
                    if (index<2) {
                      return (
                        <div className={styles.related_item}>
                           <div className='pic' style={{backgroundImage: `url(${item['thumb']?item['thumb']:noImg})`}}/>
                          <div className='product_name'>{item.name}</div>
                          <div className='product_brand'>{item.brand} {item['factoryCode']}</div>
                        </div>
                        )
                    }
                  })
                }
              </div>

            </div> */}
          </div>
          {/* <div className='cart_container' onClick={() => {
              history.push('/cart')
            }} >
          </div> */}
          {/* <Modal
            title={isBuy ? t('购买') : t('租赁')}
            footer={false}
            centered
            getContainer={false}
            visible={visible}
            zIndex={9999}
            onOk={() => setVisible(false)}
            onCancel={() => setVisible(false)}
            width={600}
          >
            <div className={[styles.detailContent, styles.modal].join(" ")}>

                <div className={styles.confirm}>

                  <div className={styles.txt}><i className='icon icon-check'/> {t('已加入购物车，欢迎询价')}</div>


                  <div className={styles.btnGroup}>
                    <Button type='primary' size='large' ghost
                            onClick={() => setVisible(false)}>&lt; {t('返回商品详情')}</Button>
                    <Button type='primary' size='large' onClick={() => history.push('/cart')}>{t('去购物车')}</Button>
                  </div>

                </div>

            </div>


          </Modal> */}

        </div>

      )}

    </React.Fragment>
  )

})